import React from 'react'
import { useLocation } from 'react-router-dom'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'
import NavigationItem from 'components_new/molecules/NavigationItem'

import { useActiveSource } from 'redux/hooks/Sources'
import { useParams } from 'utils/hooks'
import { getSourceTabs } from 'utils/sources'

interface SourceNavigationProps {
  sx?: SxProps
}

const SourceNavigation = (props: SourceNavigationProps) => {
  const { sx } = props

  const { id, sourceType } = useParams<{ id: string; sourceType: string }>()
  const { search } = useLocation()
  const { source } = useActiveSource(id)

  if (!source) {
    return null
  }

  const base = `/data-platform/collect/${sourceType}/${id}`

  return (
    <Box sx={sx}>
      {getSourceTabs(source.attributes).map((item) => (
        <NavigationItem
          item={{
            activePattern: `${base}/${item.tab}`,
            href: `${base}/${item.tab}`,
            icon: { name: item.icon },
            // Keeps the selected table when moving between sections.
            search: search,
            title: item.label
          }}
          key={item.tab}
        />
      ))}
    </Box>
  )
}

export default SourceNavigation
